class HourlyProducts extends HTMLElement {
  constructor() {
    super();

    this.hourlyInterval = parseInt(this.getAttribute("data-interval"));
    this.sectionId = this.getAttribute("data-section-id");
    this.collectionhandle = this.getAttribute("data-collection-handle");
  }

  getPageNumb(hour, times) {
    return Math.ceil((hour + 1) / times);
  }

  calculatePageNumb() {
    var nowDate = new Date();
    this.pageNumb = this.getPageNumb(nowDate.getHours(), this.hourlyInterval);

    /* never more than page 4, as agreed to with merchant... */
    if (this.pageNumb > 4) {
      this.pageNumb = this.pageNumb % 4;

      /* deal with e.g. page 8 being == 0, as we do modulo on it... let's not request page 0 :D */
      if (this.pageNumb == 0) {
        this.pageNumb = 4;
      }
    }
  }

  renderRes(resJSON) {
    this.domParser = new DOMParser();
    this.sectionRawHTML = this.domParser.parseFromString(
      resJSON[this.sectionId],
      "text/html"
    );

    this.innerHTML = this.sectionRawHTML.querySelector(".shopify-section").innerHTML;
    this.registerExpandBtn();
  }

  registerExpandBtn() {
    this.expandBtn = this.querySelector('button[name="expand"]');
    this.expandBtn.addEventListener('click', this.expandProducts.bind(this));
  }

  expandProducts() {
    this.expandBtn.removeEventListener('click', this.expandProducts);
    this.btnContainer = this.querySelector('[data-btn-expander]');
    this.btnContainer.remove();

    this.classList.add('expanded');
  }

  connectedCallback() {
    this.calculatePageNumb();
    this.requestURL = new URL(window.location.href);
    this.requestURL.pathname = "/collections/" + this.collectionhandle;
    this.requestURL.searchParams.set("sections", this.sectionId);
    this.requestURL.searchParams.set("page", this.pageNumb);

    fetch(this.requestURL.toString())
      .then((res) => res.json())
      .then((resJSON) => {
        this.renderRes(resJSON);
      })
      .catch((err) => console.warn(err));
  }
}

customElements.define("hourly-products", HourlyProducts);
